<div class="banner-subpage withbreadcrumbs" *ngIf="((this.authService.IsUserRole(this.authService.UserRole.Admin) ||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)|| this.authService.IsUserRole(this.authService.UserRole.Broker)) && !callFromComponent)">
  <h2 class="bighead">Live Listings</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li>
      <span *ngIf="prevRoute == null">Properties <span style="padding:8px;">|</span></span>
      <a *ngIf="prevRoute != null" (click)="onBreadCrumbClick()">{{prevRoute}}</a><span *ngIf="prevRoute != null" style="padding:8px;">|</span>
    </li>
    <li>Live Listings</li>
  </ul>
  <div class="search-div advanced-search-div clearfix search-div-02 buy-page-advance-search">
    <my-property-search (propertySearchCriteria)="propertySearchCriteria($event)" #searchComp></my-property-search>
  </div>
</div>
<div class="container container-lg section-margin min-heightcontainer p_1" (click)="divClicked()" *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Admin)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff) || this.authService.IsUserRole(this.authService.UserRole.Broker)) && !callFromComponent">
  <div class="border-div list-box table-fixed margin0">
    <div class="floatinghead floatinghead-xs clearfix p-1" *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)  || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff))">

      <!--<h2 class="mainhead">
          <span class="text">My Properties</span>
          <span class="countstyle">{{propertyCount}}</span>
      </h2>-->
      <div>
        <ul class="switchingproperty margin-bottom-10">
          <li [class.active]="currentTab === propertyType.Sale">
            <a href="javascript:void(0);" (click)="loadMyproperty(propertyType.Sale);onRedirection();">
              B+E Listings
              <span class="countstyle" *ngIf="currentTab === propertyType.Sale">{{propertyCount}}</span>
            </a>
          </li>
          <li [class.active]="currentTab === propertyType.Exchange1031">
            <a href="javascript:void(0);" (click)="loadMyproperty(propertyType.Exchange1031);onRedirection();">
              Net Lease Market
              <span class="countstyle" *ngIf="currentTab === propertyType.Exchange1031">{{propertyCount}}</span>
            </a>
          </li>
        </ul>
        <div class="absolutesearch margin-right-15">
          <div *ngIf="!this.authService.IsUserRole(this.authService.UserRole.Broker)" class="btn-group right-btn rightdropdown" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn  btn-circle btn-green margin-bottom dropdown-toggle"
                    aria-controls="dropdown-basic">
              <i aria-hidden="true" class="fa fa-plus icon"></i>
            </button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" href="#" [routerLink]="['/property']">Add Property</a></li>
              <li role="menuitem"><a class="dropdown-item" href="#" [routerLink]="['/propertyimport']">Bulk Import</a></li>
              <li *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" role="menuitem"><a class="dropdown-item" href="#" [routerLink]="['/property']" [queryParams]="{isPortfolio:true}">Add Portfolio</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="floatinghead floatinghead-xs clearfix">

        <button class="right-btn btn-border  btn adduserbtn margin-bottom-15" *ngIf="propertiesEx?.length !== 0 " (click)="exportToExcel();">Export To Excel</button>
        <button *ngIf="totalSourceChangedCount !== 0" class="right-btn btn-border margin-right-10 btn warningbtn margin-bottom-15"><span class="icon-warning "></span> {{Validation.formatNumberToTwoDigit(totalSourceChangedCount)|number}} Properties</button>
        <div *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)|| this.authService.IsUserRole(this.authService.UserRole.Admin))" class="btn-group right-btn rightdropdown margin-right-10 adduserbtn margin-bottom-15" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15 dropdown-toggle"
                  aria-controls="dropdown-basic">
            Share
          </button>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
              role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareListing(ShareListing,'panlestyle');">Share Listings</a></li>
            <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareOM(ShareOM,'portfolio-bov-modal shareom-document-modal');">Share OM</a></li>
          </ul>
        </div>
        <!--<button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15" *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin))" (click)="openModalForShareListing(ShareListing,'panlestyle');">Share Listings</button>-->
        <div *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" class="margin-bottom-15  margin-right-15 displayinlineblockdiv" style="float:left">
          <!--<label class="form-label"></label>-->
          <label class="select">
            <select class="form-control" [(ngModel)]="selectedAction" (change)="onActionSelect($event,bulkAction,'panlestyle',CompOrArchive,AssignBroker,BulkDelete);" style="width:150px">
              <option value="0"> Bulk Actions</option>
              <option value="1">Change Status</option>
              <!-- <option value="2">Mark As Comp</option>-->
              <option value="3">Mark As Archive</option>
              <option value="4" *ngIf="currentTab === propertyType.Sale">Assign Broker</option>
              <option value="6">Merge Records</option>
              <!--<option value="5">Delete</option>-->
            </select>
            <i></i>
          </label>
        </div>
        <div class="pull-left visible-lg margin-left-5 margin-top-5">
          <!--<label class="form-label">&nbsp;</label>-->
          <p class="selected-rows-count be-tag-01 margin-bottom-0" *ngIf="selectedRows?.length > 0">
            {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
            <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
          </p>
        </div>
        <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right">
          <mat-form-field>
            <mat-select placeholder="Select Columns" [(ngModel)]="selectedColumns" (ngModelChange)="onSelectedColumsChange()" multiple>
              <!-- @if (selectedColumns?.length > 1) {
                <mat-select-trigger>
                  <span>{{ selectedColumns?.length }} checked</span>
                </mat-select-trigger>
              } -->
              <mat-select-trigger>
                <span>Select Columns</span>
              </mat-select-trigger>
              @for (column of tableColumns; track column) {
              <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
              }
              @if (tableColumns.length === 0) {
              <mat-option class="matoptionnodata" disabled>
                Nothing found...
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="clearfix"></div>
        <p class="selected-rows-count margin-bottom-10 hidden-lg text-right " *ngIf="selectedRows?.length > 0">
          <span class="be-tag-01">
            {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
            <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
          </span>
        </p>
      </div>
      <!--<button class="right-btn btn  btn-circle btn-green margin-bottom" [routerLink]="['/property']" ng-reflect-placement="top" ng-reflect-tooltip="Assign Property" placement="top" tooltip="Add Property"><i aria-hidden="true" class="icofont icofont-plus icon"></i></button>
      <button class="right-btn btn  btn-green margin-bottom" [routerLink]="['/propertyimport']" ng-reflect-placement="top" ng-reflect-tooltip="Import Property" placement="top" tooltip="Import Property">Import</button>-->

    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
            <colgroup>
              <col style="width:50px" [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin)||(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) || (this.authService.IsUserRole(this.authService.UserRole.Broker)))">
              <col style="width:130px" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">
              <col style="width:60px">
              <col [hidden]="true" style="width:170px">
              <col style="width:200px !important;">
              <col [hidden]="!enableMessage" width="100">
              <col [hidden]="hideColumn(1)">
              <col [hidden]="hideColumn(2)">
              <col [hidden]="hideColumn(3)">
              <col [hidden]="hideColumn(4)" style="width:120px">
              <col [hidden]="!is1031Property || (is1031Property && hideColumn(5))">
              <col [hidden]="hideColumn(6)" style="width:140px">
              <col [hidden]="hideColumn(7)">
              <col [hidden]="hideColumn(8)">
              <col [hidden]="hideColumn(10)">
              <col [hidden]="hideColumn(11)">
              <col [hidden]="hideColumn(12)">
              <col [hidden]="hideColumn(13)">
              <col [hidden]="hideColumn(14)">
              <col [hidden]="hideColumn(15)">
            </colgroup>
            <thead>
              <tr>
                <th [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin) ||(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) || (this.authService.IsUserRole(this.authService.UserRole.Broker)))" data-orderable="false">
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </th>
                <th *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" style="position:static; cursor:default" ng-disabled="true">Actions</th>
                <th class="remove" style="position:static; cursor:default" ng-disabled="true" data-orderable="false"></th>
                <th class=" property-name-column sticky-left z-100" [hidden]="true">Property Id</th>
                <th class="property-name-column sticky-left z-100">Tenant Name</th>

                <th [hidden]="(!this.authService.IsUserRole(this.authService.UserRole.Admin)&&!this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) || hideColumn(1)" style="min-width:70px;">Source Change</th>
                <th class="whitespacenowrap" [hidden]="hideColumn(2)">Last Updated</th>
                <th [hidden]="hideColumn(3)">State</th>
                <th [hidden]="hideColumn(4)">City</th>
                <!--<th>Property For</th>-->
                <!--<th>Broker</th>-->
                <th [hidden]="!is1031Property || (is1031Property && hideColumn(5))">Brokerage</th>
                <!--<th>Property Status</th>-->
                <th [hidden]="hideColumn(6)">Status</th>
                <th [hidden]="hideColumn(7)">Asking Price</th>
                <th [hidden]="hideColumn(8)">Rent NOI</th>
                <th [hidden]="hideColumn(9)">Credit Rating</th>
                <th [hidden]="hideColumn(10)">Cap Rate</th>
                <th [hidden]="hideColumn(11)">Remaining Term</th>
                <th class="whitespacenowrap" [hidden]="hideColumn(16)">Date On Market</th>
                <th [hidden]="hideColumn(12)">Lease Structure</th>
                <th [hidden]="hideColumn(13)">Area (SQ FT)</th>
                <th [hidden]="hideColumn(14)">Source URL</th>
                <th [hidden]="hideColumn(15)">Rank</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let prop of propertiesEx; let i=index">
                <tr [class.portfoio-list]="prop.IsPortfolio">
                  <td [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin)||(this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) || (this.authService.IsUserRole(this.authService.UserRole.Broker)))" class="first-td">
                    <label class="custom-checkbox withoutlabel">
                      <input type="checkbox" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                    </label>
                  </td>
                  <td *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" class="whitespacenowrap">
                    <a href="javascript:void(0);" routerLink="/property/{{prop.Slug ? prop.Slug : prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url,isPortfolio:prop.IsPortfolio}" class="blueone" tooltip="Edit" placement="right" container="body">
                      <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                    </a>
                    <a class="blueone quick-edit"  placement="right" container="body" tooltip="Quick Edit" href="javascript:void(0);" (click)="openModalForQuickEdit(QuickEdit,'panlestyle',prop.Guid,prop.State,prop.City,prop.BrokerageName)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
                    <a href="javascript:void(0);" *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) && currentTab === propertyType.Exchange1031" class="blueone" tooltip="Verify" (click)="VerifyProperty(prop.Id, prop.IsPortfolio)"  placement="right" container="body">
                      <i class="icofont icofont-ui-check" aria-hidden="true"></i>
                    </a>
                    <a class="remove" tooltip="Remove"  placement="right" container="body" href="javascript:void(0);" (click)="openModal(template,'deletemodal',prop.Guid,prop.PropertyName,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    <a href="javascript:void(0);" class="blueone" *ngIf="prop.HasDuplicate && (this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',prop.Id)"  placement="right" container="body" style="line-height:32px;">
                      <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                    </a>
                  </td>

                  <td>
                    <a href="#" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}" [ngClass]="{'be-list': (prop.PropertyForId == 601 && currentTab === propertyType.Exchange1031)}">
                      <div class="property-image portfolio-img" *ngIf="prop.IsPortfolio">
                        <ng-container *ngIf="prop.IsPortfolio && prop.PortfolioProperties && prop.PortfolioProperties.length == 0">
                          <img [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                        </ng-container>
                        <ng-container *ngIf="prop.PortfolioProperties && prop.PortfolioProperties.length > 0">
                          <ng-container *ngFor="let image of prop.PortfolioProperties;  let im=index">
                            <img *ngIf="im < 1" [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />

                            <img *ngIf="im < 3" [src]="image.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                          </ng-container>
                        </ng-container>
                      </div>
                      <div class="property-image" *ngIf="!prop.IsPortfolio" [ngClass]="{'be-list': (prop.PropertyForId == 601 && currentTab === propertyType.Exchange1031)}">
                        <img [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                      </div>
                    </a>
                  </td>
                  <td [hidden]="true"><p class="d-flex">{{prop.PropertySequenceId}}</p></td>
                  <td class="sticky-left">
                    <p class="d-flex">
                      <span *ngIf="prop.IsPortfolio" (click)="showPortfolioProperties(prop.Id, i)" class="btn-collapse" [class.span-open]="this.propertiesEx[i].ShowPortfolioProperties">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                      </span>
                      <a href="#" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">{{ prop.PropertyName }}</a>
                      <a href="javascript:void(0);" class="blueone" *ngIf="prop.HasDuplicate && this.authService.IsUserRole(this.authService.UserRole.Broker)" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',prop.Id)" placement="top" style="line-height:32px;">
                        <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                      </a>

                    </p><sub>{{prop.PropertySequenceId}}</sub>


                  </td>
                  <td [hidden]="(!this.authService.IsUserRole(this.authService.UserRole.Admin)&&!this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) || hideColumn(1)">
                    <span *ngIf="prop.IsSourceChanged ===1" class="warningsymbol"><i class="icon icon-warning"></i></span>
                    <p *ngIf="prop.IsSourceChanged !==1">-</p>
                  </td>
                  <td class="whitespacenowrap" [hidden]="hideColumn(2)">
                    <p> {{prop.LastVerifiedDate ? (Validation.convertUTCDateToLocalDate(prop.LastVerifiedDate)| date:'MM/dd/yyyy h:mm a') :'-'}}</p>

                  </td>
                  <td [hidden]="hideColumn(3)"><p>{{prop.State ? prop.State : '-'}}</p></td>
                  <td [hidden]="hideColumn(4)"><p style="min-width:80px;">{{prop.City ? prop.City : '-'}}</p></td>




                  <td [hidden]="!is1031Property || (is1031Property && hideColumn(5))"><p>{{prop.BrokerageName ? prop.BrokerageName : '-'}}</p></td>
                  <td [hidden]="hideColumn(6)"><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                  <td [hidden]="hideColumn(7)">
                    <p *ngIf="prop.Unpriced" class="whitespacenowrap">Unpriced</p>
                    <p *ngIf="!prop.Unpriced" class="whitespacenowrap">{{(prop.Price!=null&&prop.Price>=0) ? ('$ '+ (prop.Price |number:0)) : '-'}}</p>
                  </td>
                  <td [hidden]="hideColumn(8)"><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
                  <!--<td><p>{{ (prop.RentNOI) ? (prop.RentNOI | currency:'USD':true) : '-' }}</p></td>-->

                  <td [hidden]="hideColumn(9)"><p>{{ prop.Rating ? prop.Rating  : '-' }}</p></td>
                  <td [hidden]="hideColumn(10)">
                    <p *ngIf="prop.capRateText == 'ZCF'">{{prop.capRateText}}</p>
                    <p *ngIf="prop.capRateText != 'ZCF'" class="whitespacenowrap">{{ prop.CapRate ? prop.CapRate + '%' : '-'}}</p>
                  </td>

                  <td [hidden]="hideColumn(11)"><p class="whitespacenowrap">{{ !prop.IsPortfolio ? (prop.Remaining_Term ? (prop.Remaining_Term) : '-') : (prop.PortfolioRemainingLeaseTerm ? (prop.PortfolioRemainingLeaseTerm) : '-')}}</p></td>
                  <td [hidden]="hideColumn(16)">
                    <p> {{prop.DateOnMarket ? (Validation.convertUTCDateToLocalDate(prop.DateOnMarket)| date:'MM/dd/yyyy') :'-'}}</p>
                  </td>

                  <td [hidden]="hideColumn(12)"><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
                  <td [hidden]="hideColumn(13)"><p class="whitespacenowrap">{{ prop.BuildingSize ? (prop.BuildingSize | number:0) : '-' }}</p></td>
                  <td [hidden]="hideColumn(14)"><p *ngIf="prop.SourceUrl" style="margin:5px 0 0 -3px"><a href="javascript:void(0);" target="_blank" [href]="prop.SourceUrl"><i class="fa fa-external-link" aria-hidden="true"></i> View Site</a></p></td>
                  <td [hidden]="hideColumn(15)"><p>{{ prop.Rank}}</p></td>
                </tr>
                <ng-container *ngIf="this.propertiesEx[i].ShowPortfolioProperties">
                  <tr *ngFor="let propChild of prop.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class]="this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) ? (prop.IsViewed == 0 ? 'unvisited':'visited'): '' " [class.tr-collapse]="this.propertiesEx[i].ShowPortfolioProperties">
                    <td [hidden]="!(this.authService.IsUserRole(this.authService.UserRole.Admin) || (this.authService.IsUserRole(this.authService.UserRole.Broker)))" data-orderable="false">
                    </td>
                    <td *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" class="whitespacenowrap">
                    </td>
                    <td style="position:relative;" class="pro-img-td hidden-xs">
                      <a href="javascript:void(0);" (click)="onViewProperty(propChild.Slug ? propChild.Slug : propChild.Guid)" [ngClass]="{'be-list': (propChild.PropertyForId == 601 && currentTab === propertyType.Exchange1031)}">
                        <div class="property-image" *ngIf="propChild.FilePath !=null" [ngStyle]="{'background-image': 'url(' + propChild.FilePath + ')'}"></div>
                        <div class="property-image" *ngIf="propChild.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
                      </a>
                    </td>
                    <td [hidden]="true"></td>
                    <td class="sticky-left">
                      <p><a href="javascript:void(0);" routerLink="/viewproperty/{{propChild.Slug ? propChild.Slug : propChild.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">{{ propChild.PropertyName }}</a></p><sub>{{propChild.PropertySequenceId}}</sub>

                    </td>
                    <td [hidden]="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || hideColumn(1)">
                      <span *ngIf="propChild.IsSourceChanged ===1" class="warningsymbol"><i class="icon icon-warning"></i></span>
                      <p *ngIf="propChild.IsSourceChanged !==1">-</p>
                    </td>
                    <td [hidden]="hideColumn(2)"><p> {{propChild.LastVerifiedDate ? (Validation.convertUTCDateToLocalDate(propChild.LastVerifiedDate)| date:'MM/dd/yyyy h:mm a') :'-'}}</p> </td>

                    <td [hidden]="hideColumn(3)"><p>{{ propChild.State ? propChild.State : '-' }}</p></td>
                    <td [hidden]="hideColumn(4)"><p>{{ propChild.City ? propChild.City : '-' }}</p></td>
                    <td [hidden]="!is1031Property || (is1031Property && hideColumn(5))"></td>
                    <td [hidden]="hideColumn(6)"><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market'}">{{ propChild.PropertyStatus }}</p></td>
                    <td [hidden]="hideColumn(7)">
                      <p class="whitespacenowrap" *ngIf="propChild.Unpriced">Unpriced</p>
                      <p class="whitespacenowrap" *ngIf="!propChild.Unpriced">{{(propChild.Price>=0&&propChild.Price!=null&& propChild.IsShowPrice) ? '$ '+(propChild.Price |number:0) : '-'}}</p>
                    </td>

                    <td [hidden]="hideColumn(8)"><p class="whitespacenowrap">{{propChild.RentNOI ? '$ '+(propChild.RentNOI | number:0) : '-' }}</p></td>

                    <td [hidden]="hideColumn(9)"><p>{{ propChild.Rating ? propChild.Rating : '-' }}</p></td>
                    <td [hidden]="hideColumn(8)">
                      <p *ngIf="propChild.CharacteristicsId == 0">{{ (propChild.CapRate && propChild.IsShowPrice) ? (propChild.CapRate | number : '1.2-2') + '%' : '-'}}</p>
                      <p *ngIf="propChild.CharacteristicsId == 1">ZCF</p>
                    </td>
                    <td [hidden]="hideColumn(11)"><p class="whitespacenowrap">{{ propChild.RemainingTerm ? (propChild.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
                    <td [hidden]="hideColumn(16)">
                      <p> {{propChild.DateOnMarket ? (Validation.convertUTCDateToLocalDate(propChild.DateOnMarket)| date:'MM/dd/yyyy') :'-'}}</p>
                    </td>
                    <td [hidden]="hideColumn(12)"><p class="whitespacenowrap">{{ propChild.LeaseStructure ? propChild.LeaseStructure : '-'}}</p></td>
                    <td [hidden]="hideColumn(13)"><p>{{ propChild.BuildingSize ? (propChild.BuildingSize |number:0) : '-' }}</p></td>
                    <td [hidden]="hideColumn(14)">
                      <p *ngIf="propChild.SourceUrl" style="margin:5px 0 0 -3px"><a href="javascript:void(0);" target="_blank" [href]="propChild.SourceUrl"><i class="fa fa-external-link" aria-hidden="true"></i> View Site</a></p>
                    </td>
                  </tr>
                  <tr class="tr-gap">
                    <td colspan="12"></td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
            <tfoot>
              <tr *ngIf="propertiesEx?.length == 0 &&!IsLoading">
                <td colspan="17" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Data Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) || callFromComponent">
  <div class="innerpage-fullwithbanner" *ngIf="!callFromComponent">
    <h2 class="bighead">My Offers</h2>
    <ul class="bread-crumbs">
      <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
      <li>My Offers</li>
    </ul>
  </div>
  <div class="featuredproperties section-margin">
    <div class="container container-lg min-heightcontainer">
      <div class="row">
        <div class="col-lg-12 ">
          <div class="border-div table-fixed margin0">
            <div class="floatinghead clearfix">
              <h2 class="mainhead "><span class="text">My Offers</span></h2>
              <div class="rightside clearfix">
                <div class="search-sec">
                  <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                  <i class="fa fa-search icon" aria-hidden="true"></i>
                </div>
                <!--<a class="filter btn  btn-circle btn-blue" href="#"><i class="fa fa-filter icon" aria-hidden="true"></i></a>
                <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);"><i class="fa fa-plus icon" aria-hidden="true"></i></a>-->
              </div>
            </div>
            <div class="floatinghead be-tab-02 clearfix">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a [class.active]="selectedSubTab == 1" href="javascript:void(0);" (click)="ArchiveTab(1);" class="nav-link active">
                    Active
                  </a>
                </li>
                <li class="nav-item">
                  <a [class.active]="selectedSubTab == 2" href="javascript:void(0);" (click)="ArchiveTab(2);" class="nav-link">
                    Inactive
                  </a>
                </li>
              </ul>
            </div>
            <div class="table-responsive">
              <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                <thead>
                  <tr>
                    <th [hidden]="selectedSubTab == 2 && !authService.Admin()&&!authService.SuperAdmin" style="width:75px" class="remove sorting_disabled sticky-left z-100" data-orderable="false">Action</th>
                    <th class="remove sorting_disabled" data-orderable="false"></th>
                    <th data-orderable="false" [hidden]="(this.authService.Broker()||this.authService.Principal()||this.authService.Principal1031()||this.authService.ExternalBroker())&&(exchangeSelected == null ||exchangeSelected == 0 ||exchangeSelected == undefined)?false:true">Questionnaire</th>
                    <th [hidden]="!IsExternalBroker" class="min-width-td">Principal</th>
                    <th class="min-width-td">Tenant</th>
                    <th>Status</th>
                    <th>Broker</th>
                    <th>Asking Price</th>
                    <th>Offer Price</th>
                    <th>Earnest Money Deposit</th>
                    <th>Due Diligence Period (Days)</th>
                    <th>HC Period (Days)</th>
                    <th>Comments</th>
                    <!--<th>Notes</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let offer of offers ">
                    <td [hidden]="selectedSubTab == 2 && !authService.Admin()&&!authService.SuperAdmin" class="whitespacenowrap sticky-left">
                      <a class="bluetwo mr-5" [ngClass]="{'newnote': offer.UnReadNoteCount!=0}" tooltip="Notes" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',offer.LeadId,offer)" placement="right">
                        <i class="icon-inquiry" aria-hidden="true"></i>
                      </a>
                      <div *ngIf="offer.IsLatest && (offer.StatusId==451 || offer.StatusId==458||offer.StatusId==461) && offer.StatusId != 457" class="displayinlineblockdiv">
                        <a href="javascript:void(0);" (click)="redirect(offer.PropertyGuid,offer.OfferDetailGuid);" class="blueone" tooltip="Edit" placement="right">
                          <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div *ngIf="authService.Admin()||authService.SuperAdmin()" class="displayinlineblockdiv">
                        <a class="remove" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" tooltip="Remove" href="javascript:void(0);" (click)="openModalDeleteOffer(OfferDelete,'deleteOffermodal',offer.LeadId,index)" placement="right"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                      </div>
                      <div class="displayinlineblockdiv" *ngIf="(exchangeSelected == null ||exchangeSelected == 0 || exchangeSelected == undefined)">
                        <a *ngIf="this.authService.Broker()&&!offer.IsDraft &&(offer.QuestionareIsDraft ||(offer.NotAnsweredQustionsCount)!=34) && offer.IsHaveRemainderPermission==1" href="javascript:void(0);" tooltip="Send Reminder" (click)="SendBuyerQuestionsRemainder(offer.LeadId)" class="remove" placement="top">
                          <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
                        </a>
                      </div>
                    </td>
                    <td>
                      <div *ngIf="offer.FilePath" class="displayinlineblockdiv">
                        <a class="border-link" href={{offer.FilePath}} download="Document.pdf" target="_blank" ng-reflect-placement="top" ng-reflect-tooltip="Download" placement="top" tooltip="Download" triggers="hover">
                          <i aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>LOI
                        </a>
                      </div>
                    </td>
                    <td class="whitespacenowrap" *ngIf="(this.authService.Broker()||this.authService.Principal()||this.authService.Principal1031()||this.authService.ExternalBroker())&&offer.IsHaveQuestionPermission==1&&(exchangeSelected == null || exchangeSelected == 0 ||exchangeSelected == undefined)">
                      <p><a href="javascript:void(0);" *ngIf="!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal  modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                      <span *ngIf="offer.QuestionareIsDraft&&!offer.IsDraft" class="red">(Draft)</span>
                      <span *ngIf="offer.IsDraft">-</span>
                    </td>
                    <td class="whitespacenowrap" *ngIf="(this.authService.Broker()||this.authService.Principal()||this.authService.Principal1031()||this.authService.ExternalBroker())&&offer.IsHaveQuestionPermission==0&&(exchangeSelected == null || exchangeSelected == 0 || exchangeSelected == undefined)">
                      <p><a href="javascript:void(0);" *ngIf="!offer.QuestionareIsDraft&&offer.IsHaveRemainderPermission==1&&!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal  modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                      <span *ngIf="(offer.QuestionareIsDraft||offer.IsHaveRemainderPermission!=1||offer.IsDraft)">-</span>
                    </td>
                    <td *ngIf="IsExternalBroker">
                      <p style="font-weight:600">{{ offer.LeadName }} </p>
                      <p *ngIf="offer.BuyerName">on behalf of {{offer.BuyerName}}</p>
                      <p *ngIf="offer.LeadPhone">{{ offer.LeadPhone | phone }}</p>
                      <p *ngIf="offer.LeadEmail">{{offer.LeadEmail}}</p>
                    </td>
                    <td>
                      <!--<p>{{ (offer.TenantName!=null && offer.TenantName!=" ") ? (offer.TenantName) : "-" }}</p>-->
                      <p><a href="javascript:void(0);" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:BreadCrumb.PrevPageName,link:BreadCrumb.PrevPageLink}">{{ (offer.TenantName!=null && offer.TenantName!=" ") ? (offer.TenantName) : "-" }}</a></p>

                    </td>
                    <td><span class="status-blue">{{offer.StatusName =='Cancelled' ? 'Canceled' :offer.StatusName}}</span><br /><span class="red" *ngIf="offer.IsDraft">(Draft)</span></td>
                    <td>
                      <p>{{ offer.PrimaryContactName }}</p>
                      <!--<p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>-->
                    </td>
                    <td>
                      <p *ngIf="offer.Unpriced" class="whitespacenowrap">Unpriced</p>
                      <p *ngIf="!offer.Unpriced" class="whitespacenowrap">{{(offer.Price!=null&&offer.Price>=0) ? '$ '+ (offer.Price | number:0) : '-'}}</p>
                    </td>
                    <td>
                      <p class="whitespacenowrap">
                        {{(offer.OfferPrice!=null&&offer.OfferPrice>=0) ?'$ '+ (offer.OfferPrice | number:0) : '-'}}
                      </p>
                    </td>
                    <td><p class="whitespacenowrap">{{(offer.EarnestMoneyDeposit) ?'$ '+ (offer.EarnestMoneyDeposit | number:0) : '-'}}</p></td>
                    <td>{{(offer.DueDiligencePeriod) ? (offer.DueDiligencePeriod | number:0) : '-'}}</td>
                    <td>{{(offer.ClosingPeriod) ? (offer.ClosingPeriod | number:0) : '-'}}</td>
                    <td><p class="ellipsis-text commentpara">{{offer.Comments}} <button class="eyeicon" container="body" triggers="focus" popover="{{offer.Comments}}"><i class="fa fa-eye" aria-hidden="true"></i></button></p></td>
                    <!--<td class="whitespacenowrap">
                        <a class="blueone" tooltip="AddNotes" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle',offer.LeadId,objectTypeId)">
                        <i class="icon-inquiry" aria-hidden="true"></i>
                            </a>
                    </td>-->

                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="offers?.length == 0 ">
                    <td colspan="10" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Property ?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete {{property}} ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteProperty();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>
<ng-template #notestemplate>
  <app-shared-add-notes (close)="closeModal" [modalRef]="modalRef" [notesInputsModel]="NotesInput"></app-shared-add-notes>
  <!--<app-notes-details (close)="closeModal" [modalRef]="modalRef"></app-notes-details>-->
</ng-template>

<ng-template #bulkAction>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">
        Change Status of selected {{getSelectedCount()}} properties
        <span class="star">*</span>
      </label>
      <label class="select">
        <select [(ngModel)]="statusToChange" #propStatus="ngModel" class="form-control">
          <option value="0">--Select--</option>
          <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="showSelectStatus || (propStatus.touched && statusToChange == 0)">Please select status</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="changeStatus();">Update</button>
    </div>
  </div>

</ng-template>


<ng-template #CompOrArchive>

  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ConfirmationHeading}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">{{confirmBody}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="markCompOrArchive();modalRef.hide();">Update</button>
    </div>
  </div>

</ng-template>

<ng-template #AssignBroker>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Assign Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <label class="form-label">
        State
        <span class="star">*</span>
      </label>
      <label class="select">
        <select [(ngModel)]="assignBrokerInputModel.stateId" #state="ngModel" (change)="onStateSelect()" class="form-control">
          <option value="0">--Select--</option>
          <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="(assignClicked && assignBrokerInputModel.stateId == 0)||(state.touched && assignBrokerInputModel.stateId == 0)">Select State</p>
    </div>
    <div class="form-group">
      <label class="form-label">Broker<span class="star">*</span></label>
      <label class="select">
        <select name="cmbBroker" #broker="ngModel" required (change)="onBrokerChange($event)" [(ngModel)]="assignBrokerInputModel.brokerId"
                #cmbBroker="ngModel"
                class="form-control ">
          <option value="0">--Select--</option>
          <option *ngFor="let broker of brokers" [(ngValue)]="broker.Id">{{broker.Name}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="(assignClicked && assignBrokerInputModel.brokerId == 0)||(broker.touched && assignBrokerInputModel.brokerId == 0)">Select Broker</p>
    </div>
    <div class="form-group">
      <label class="form-label">Licence<span class="star">*</span></label>
      <label class="select">
        <select name="cmbLicense" #licence="ngModel" (change)="onLicenceSelected($event)" #cmbLicense="ngModel" required
                [(ngModel)]="assignBrokerInputModel.licenseId" class="form-control ">
          <option value="0">--Select--</option>
          <option *ngFor="let lic of brokerLicenses" [ngValue]="lic.BrokerRegionalLicenseId">{{lic.License}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="(assignClicked && assignBrokerInputModel.licenseId == 0)||(licence.touched && assignBrokerInputModel.licenseId == 0)">Select Licence</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="assignBroker();">Assign</button>
    </div>
  </div>

</ng-template>


<ng-template #BulkDelete>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Properties</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to Delete the selected {{getSelectedCount()}} properties ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onbulkDelete();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #OfferDelete>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Offer Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete this offer?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteOffers();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #QuickEdit>
  <app-quick-edit-property [selectedPropertyId]="selectedPropertyId" [quickEditDetails]="quickEditDetails" (closeModal)="closeModal($event)" [isDataEntryProperty]="isDataEntryProperty"></app-quick-edit-property>
</ng-template>

<ng-template #ShareListing>
  <app-share-group-add [selectedProperties]="selectedProperties" [modalRefShareListing]="modalRefShareListing" (removeProperties)="removeProperty($event)"></app-share-group-add>
</ng-template>

<ng-template #DuplicateProperty>
  <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [prevRoute]="'LiveListings'" [pageIndex]="1" [modalRef]="modalRefDuplicate" [Type]="1"></app-duplicate-property-list>
</ng-template>

<ng-template #BuyerQuestinnaire>
  <app-Buyer-Questionnaire [modalBuyerRef]="modalBuyerRef" [OfferId]="BuyerQuestionsOfferId" [PropertyId]="BuyerQuestionsPropertyId" [source]="'OfferPlaced'" [sourceUrl]="offerPageUrl"></app-Buyer-Questionnaire>
</ng-template>

<ng-template #ShareOM>
  <app-share-omdocuments [propertyIds]="sharedOmProperties" [modalRefShareListing]="modalRefOM" (removeProperties)="removeProperty($event)"></app-share-omdocuments>
</ng-template>

